import { Box, TextField } from "@mui/material";
import { useEffect, useRef, useState } from "react";

import styles from '../../../../assets/styles/componentStyles/templateLibraryStyles/whatsappTemplatePreview.module.scss';

import WrapWithHoverUI from "../utils/WrapWithHoverUI";
import { replacingTemplateMarkdownText } from "../../../../utils/constants";
import { canUpdateTemplateFooter, getTextCharacterLimit, isTemplateCategoryAuthentication, maxFooterChars, shouldShowTemplateFooter } from "../../channels/global/whatsapp/templates/utils";
import { shouldShowFooterTextField } from "../constant";
import { useTemplateLibraryStore } from "../../../../store/templateLibraryStore";
import { useSearchParams } from "react-router-dom";

const WhatsAppMessageFooterPreview = ({ template, editable, handleChangeText, handleExpirationChange, handleSecurityRecommendationChange, handleAddExpiryTimeChange }: any) => {

    const createTemplatePayload = useTemplateLibraryStore((state) => state.createTemplatePayload);
    const existingTemplateData = useTemplateLibraryStore((state) => state.existingTemplateData);
    const templateStatusDetails = useTemplateLibraryStore((state) => state.templateStatusDetails);
    const setCreateTemplatePayload = useTemplateLibraryStore((state) => state.setCreateTemplatePayload);
    const interactiveTypeList = useTemplateLibraryStore((state) => state.interactiveTypeList);
    const templateLibraryCategoryList = useTemplateLibraryStore((state) => state.templateLibraryCategoryList);
    const whatsappTemplateTypes = useTemplateLibraryStore((state) => state.whatsappTemplateTypes);
    const addExpiryTimeForCode = useTemplateLibraryStore((state) => state.addExpiryTimeForCode);
    const setAddExpiryTimeForCode = useTemplateLibraryStore((state) => state.setAddExpiryTimeForCode);

    const [editingText, setEditingText] = useState(false);
    const footerInputRef = useRef<HTMLInputElement | HTMLTextAreaElement>(null);

    const footerValueFromPayload = createTemplatePayload?.whatsapp_template_data?.whatsapp_template_footer?.whatsapp_template_footer_value ?? "";
    const footerValueFromTemplate = template?.footer ?? "";
    const footerData = editable ? footerValueFromPayload : footerValueFromTemplate;
    
    const isAuthenticationTemplate = isTemplateCategoryAuthentication(templateLibraryCategoryList, createTemplatePayload?.whatsapp_template_data?.whatsapp_template_category_id);

    const [searchParams] = useSearchParams();
    let draftId = searchParams.get('draft_id');

    const handleFooterAreaClick = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        setEditingText(true);
    };

    const wrapWithHoverUI = (content: any) => (
        <WrapWithHoverUI
          label="Footer" 
          editable={editable} 
          onMouseLeave={() => setEditingText(false)}
        >
          {content}
        </WrapWithHoverUI>
    );
  
    const renderFooterPreview = () => (
        <>
            <Box 
                className={styles.whatsappPreview__footer}
                dir="auto"
            >
                <div
                    className={styles.whatsappPreview__textContentPreview}
                    dangerouslySetInnerHTML={{
                        __html: replacingTemplateMarkdownText(footerData) 
                            || "Enter your footer text here"
                        }}
                />
            </Box>
        </>
    );

    useEffect(() => {
        if (editingText && footerInputRef.current) {
            const textTimeout = setTimeout(() => {
                const footerInputElement = footerInputRef?.current;
                if (!footerInputElement) return;
                footerInputElement.focus();
                const footerValueLength = (createTemplatePayload?.whatsapp_template_data?.whatsapp_template_footer?.whatsapp_template_footer_value ?? '').length;
                footerInputElement.setSelectionRange(footerValueLength, footerValueLength);
            }, 0);
            return () => clearTimeout(textTimeout);
        }
    }, [editingText, footerInputRef]);

    if (!editable) {
        if (!footerData) return null;
        return renderFooterPreview();
    }

    if (!shouldShowTemplateFooter(createTemplatePayload, interactiveTypeList, existingTemplateData)) {
        return null;
    }

    const handleFooterTextDisabled = () => {
        return (
            (!canUpdateTemplateFooter(templateStatusDetails?.whatsapp_template_metadata?.meta_whatsapp_template_status_name, createTemplatePayload, whatsappTemplateTypes, draftId, existingTemplateData, createTemplatePayload?.whatsapp_template_id))
            || isAuthenticationTemplate
        )
    }

    return (
        <>
            {shouldShowFooterTextField(isAuthenticationTemplate, addExpiryTimeForCode) && (editable ? (
                wrapWithHoverUI(
                    <div onClick={handleFooterAreaClick} className={styles.whatsappPreview__editableTextFieldWrapper}>
                        {editingText ? (
                            (getTextCharacterLimit(createTemplatePayload, interactiveTypeList, "footer text limit") ?? maxFooterChars) > 0 ? (
                                <TextField
                                    multiline
                                    fullWidth
                                    inputRef={footerInputRef}
                                    InputProps={{ className: styles.whatsappPreview__textInputHoverContainer }}
                                    inputProps={{ dir: 'auto' }}
                                    // disabled={createTemplatePayload?.whatsapp_template_id ? true : false}
                                    // disabled={!canUpdateTemplate(templateStatusDetails?.whatsapp_template_metadata?.meta_whatsapp_template_status_name, createTemplatePayload?.whatsapp_template_flag_interactive_message, draftId) || !(existingTemplateData && existingTemplateData?.whatsapp_template_data?.whatsapp_template_footer?.whatsapp_template_footer_value?.length > 0)}
                                    disabled={handleFooterTextDisabled()}
                                    value={createTemplatePayload?.whatsapp_template_data?.whatsapp_template_footer?.whatsapp_template_footer_value ?? ""}
                                    className={styles.whatsappPreview__footer}
                                    onChange={(event: any) => {
                                        handleChangeText(event, 'footer');
                                        let maximumFooterCharacterLimit = getTextCharacterLimit(createTemplatePayload, interactiveTypeList, "footer text limit") ?? maxFooterChars;
                                        if(event.target.value.length <= maximumFooterCharacterLimit){
                                            setCreateTemplatePayload({
                                                ...createTemplatePayload,
                                                whatsapp_template_data: {
                                                    ...createTemplatePayload?.whatsapp_template_data,
                                                    whatsapp_template_footer: {
                                                        ...createTemplatePayload?.whatsapp_template_data?.whatsapp_template_footer,
                                                        whatsapp_template_footer_id: createTemplatePayload?.whatsapp_template_data?.whatsapp_template_footer?.whatsapp_template_footer_id ? createTemplatePayload?.whatsapp_template_data?.whatsapp_template_footer?.whatsapp_template_footer_id : 0,
                                                        whatsapp_template_footer_value: event.target.value,
                                                    }
                                                }
                                            })
                                        }
                                    }}
                                    autoComplete='off'
                                    placeholder='Enter footer text'
                                />
                            ) : (
                                renderFooterPreview()
                            )
                        ) : (
                            renderFooterPreview()
                        )}
                    </div>
                )
                ) : (
                    renderFooterPreview()
                )
            )}

            {editable && isAuthenticationTemplate && (
                <div className={styles.whatsappPreview__checkboxContainer}>
                    <div>
                        Add security recommendation
                        <input
                            type="checkbox"
                            className={styles.whatsappPreview__checkbox}
                            checked={Boolean(createTemplatePayload?.whatsapp_template_data?.whatsapp_template_security_recommendation)}
                            onChange={(e) => handleSecurityRecommendationChange(e.target.checked)}
                            disabled={!!createTemplatePayload?.whatsapp_template_id}
                        />
                    </div>

                    <div>
                        Add expiry time for the code
                        <input
                            type="checkbox"
                            className={styles.whatsappPreview__checkbox}
                            checked={addExpiryTimeForCode}
                            onChange={(e) => handleAddExpiryTimeChange(e.target.checked)}
                            disabled={!!createTemplatePayload?.whatsapp_template_id}
                        />
                    </div>

                    {addExpiryTimeForCode && (
                        <div>
                            Expiration Time
                            <input
                                type="number"
                                min={1}
                                max={90}
                                className={styles.whatsappPreview__numberInput}
                                value={createTemplatePayload?.whatsapp_template_data?.whatsapp_template_code_expiration_minutes || ""}
                                onChange={(e) => handleExpirationChange(e.target.value)}
                                disabled={!!createTemplatePayload?.whatsapp_template_id}
                            />
                        </div>
                    )}
                </div>
            )}
        </>
    );
}

export default WhatsAppMessageFooterPreview;